import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';
import { getFieldValue } from '../../util/fieldHelpers';
import { COUNTRY_LIST } from '../../config/countryConfig';

import css from './ProfilePage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata, userFieldConfig, intl } = props;

  if (!publicData || !userFieldConfig) {
    return null;
  }

  const getCountryLabel = countryValue => {
    const normalized = `${countryValue}`.toLowerCase();
    const country = COUNTRY_LIST.find(c => c.code === normalized || c.key === normalized);
    return country?.labelId ? intl.formatMessage({ id: country.labelId }) : countryValue;
  };

  const countryValueRaw = getFieldValue(publicData, 'country_of_tax_residence');
  const countryValueMaybe =
    countryValueRaw != null
      ? {
          key: 'country_of_tax_residence',
          value: getCountryLabel(countryValueRaw),
          label: intl.formatMessage({ id: 'ProfilePage.countryLabel', defaultMessage: 'Страна' }),
        }
      : null;

  const pickUserFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, userTypeConfig = {}, showConfig = {} } = config;
    const { limitToUserTypeIds, userTypeIds } = userTypeConfig;
    const userType = publicData.userType;
    const isTargetUserType = !limitToUserTypeIds || userTypeIds.includes(userType);

    const { label, displayInProfile } = showConfig;
    const publicDataValue = getFieldValue(publicData, key);
    const metadataValue = getFieldValue(metadata, key);
    const value = publicDataValue !== null ? publicDataValue : metadataValue;

    if (displayInProfile && isTargetUserType && value !== null) {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'ProfilePage.detailYes' })
          : intl.formatMessage({ id: 'ProfilePage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingUserFields = userFieldConfig
    .filter(field => field?.key !== 'country_of_tax_residence')
    .reduce(pickUserFields, []);
  const detailsToRender = countryValueMaybe
    ? [countryValueMaybe, ...existingUserFields]
    : existingUserFields;

  return detailsToRender.length > 0 ? (
    <div className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ProfilePage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {detailsToRender.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default SectionDetailsMaybe;
